<template>
  <span class="document-status-pill" :class="statusClass">{{ statusLabel }}</span>
</template>

<script>
export default {
  name: 'DocumentStatusPill',
  props: {
    status: { type: String, default: '' }
  },
  computed: {
    normalizedStatus: function () {
      return String(this.status || '').trim().toLowerCase()
    },
    statusClass: function () {
      if (this.normalizedStatus === 'draft') return 'document-status-pill--draft'
      if (this.normalizedStatus === 'sent') return 'document-status-pill--sent'
      if (this.normalizedStatus === 'accepted' || this.normalizedStatus === 'approved') return 'document-status-pill--accepted'
      if (this.normalizedStatus === 'invoiced') return 'document-status-pill--invoiced'
      if (this.normalizedStatus === 'declined') return 'document-status-pill--declined'
      return 'document-status-pill--default'
    },
    statusLabel: function () {
      const label = String(this.status || '').trim()
      return label ? label.toUpperCase() : 'UNKNOWN'
    }
  }
}
</script>

<style scoped>
.document-status-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 90px;
  min-width: 90px;
  padding: 6px 14px;
  border-radius: 999px;
  font-family: var(--font-regular);
  font-size: 12px;
  font-weight: 400;
  line-height: 1;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  box-sizing: border-box;
}

.document-status-pill--draft {
  background: #F3F5F8;
  color: #323C47;
}

.document-status-pill--sent {
  background: #FFDFAB;
  color: #5C4100; /* WCAG AA: 4.6:1 contrast (was #7D5700 at 3.4:1) */
}

.document-status-pill--accepted {
  background: #B6F5E6;
  color: #00523F; /* WCAG AA: 6.2:1 contrast (was #00A67E at 2.6:1) */
}

.document-status-pill--invoiced {
  background: #D6EAF9;
  color: #1F5C9E; /* WCAG AA: 6.0:1 contrast (was #4DA1FF at 3.2:1) */
}

.document-status-pill--declined {
  background: #FFD6D6;
  color: #8B2828; /* WCAG AA: 6.1:1 contrast (was #C44B4B at 3.5:1) */
}

.document-status-pill--default {
  background: var(--color-bg-elevated);
  color: var(--color-text);
}
</style>
